import { render, staticRenderFns } from "./FMEmpty.vue?vue&type=template&id=e97e84a2&scoped=true"
import script from "./FMEmpty.vue?vue&type=script&lang=js"
export * from "./FMEmpty.vue?vue&type=script&lang=js"
import style0 from "./FMEmpty.vue?vue&type=style&index=0&id=e97e84a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97e84a2",
  null
  
)

export default component.exports